// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2VBZd","list":"PatternAutocomplete_list__1WP6C"};